import { observer } from 'mobx-react-lite'
import { ChatbotInstructionType, type IChatbotConversationMessageType } from 'entities/Chatbot'
import { useChatbotContext, useChatbotDialogContext } from 'pages/chatbot/context'

import {
  MessageOutgoing,
  MessageOutgoingLoading,
  MessageIncoming,
  MessageIncomingLoading,
} from './MessageView'
import styles from './styles.module.scss'

const getMessageComponent = (type: IChatbotConversationMessageType) => {
  switch (type) {
    case 'user':
      return MessageOutgoing
    case 'bot':
    case 'bot_success_action':
    case 'bot_fallback_action':
    case 'bot_auto_start':
    case 'user_appointment_booked':
    case 'bot_manual_start':
    case 'bot_followup':
    case 'ai_calling_agent':
      return MessageIncoming
    default:
      return null
  }
}

export const DialogList = observer(() => {
  const dialog = useChatbotDialogContext()
  const { model } = useChatbotContext()
  const isBookAppointment = model.type === ChatbotInstructionType.BookAppointment

  return (
    <div className={styles.messageList}>
      {dialog.initialLoading ? (
        <MessageIncomingLoading isBookAppointment={isBookAppointment} />
      ) : (
        <>
          {dialog.conversation.messages.map((message) => {
            const Component = getMessageComponent(message.type)
            if (!Component) return null

            return (
              <Component key={message.id} message={message} isBookAppointment={isBookAppointment} />
            )
          })}
          {dialog.shouldShowIncomingMessage ? (
            <MessageIncomingLoading isBookAppointment={isBookAppointment} />
          ) : dialog.loading ? (
            <MessageOutgoingLoading />
          ) : null}
        </>
      )}
    </div>
  )
})
